/* eslint-disable class-methods-use-this */
import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CardConfig } from '@affinis/smartus-components/lib/card/card.component.types';
import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  NgModel,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MsalService } from '@azure/msal-angular';
import {
  AreaManagementUsageTableViewModel,
  AreaReturnSbuUsageTableViewModel,
  AreaReturnUsage,
  BaseSelectViewModel,
  BillingAreaClient,
  EmploymentClient,
  EmploymentSearchResultDto,
  LocationClient,
  RequestFileWrapperOfCostCenterAreaReturnTicketRequest,
  RequestFileWrapperOfSbuAreaReturnTicketRequest,
} from '@core/api';
import {
  AreaManagementService,
  IAreaReturnSbuUsageTableViewModel,
} from '@core/services/area-management/area-management.service';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { CostcenterSearchFormlyFieldService } from '@core/services/costcenter-search-formly-field-service/costcenter-search-formly-field.service';
import { EmployeeSearchFormlyFieldService } from '@core/services/employee-search-formly-field-service/employee-search-formly-field.service';
import { FileService } from '@core/services/file-service/file.service';
import { LocationFormlyFieldService } from '@core/services/formly-service/location-formly-field.service';
import { TicketCreateBaseComponent } from '@features/tickets/components/ticket-create/ticket-create.base';
import { MtxGridColumn } from '@ng-matero/extensions/grid';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CellTemplatesComponent } from '@shared/components/cell-templates/cell-templates.component';
import { DocumentType } from '@shared/types/document.types';
import { ToastrService } from 'ngx-toastr';
import {
  BehaviorSubject,
  Observable,
  catchError,
  debounceTime,
  distinctUntilChanged,
  of,
} from 'rxjs';
import { OverrideModule } from '../../../../app/override/override.module';
import {
  emailcc,
  fileAttachments,
} from '../tickets/ticket-create/field-configs';

export enum AreaType {
  WorkplaceOrArea = 'Büroarbeitsplätze/Technikfläche/Lagerfläche',
  BillingArea = 'Verrechnungsbereich',
}

@Component({
  selector: 'app-area-return',
  standalone: true,
  imports: [
    CommonModule,
    SmartusComponentsModule,
    TranslateModule,
    FormlyModule,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    OverrideModule,
    MatIconModule,
    MatTooltipModule,
    FormlyMatDatepickerModule,
    CellTemplatesComponent,
  ],
  providers: [DatePipe],
  templateUrl: './area-return.component.html',
  styleUrl: './area-return.component.scss',
})
export class AreaReturnComponent
  extends TicketCreateBaseComponent
  implements OnInit, OnDestroy
{
  readonly breadcrumbsService = inject(BreadcrumbService);
  override cd = inject(ChangeDetectorRef);
  override translateService = inject(TranslateService);
  override msalService = inject(MsalService);
  readonly locationFormlyFieldService = inject(LocationFormlyFieldService);
  readonly employeeSearchFormlyFieldService = inject(
    EmployeeSearchFormlyFieldService
  );
  readonly areaManagementService = inject(AreaManagementService);
  readonly costCenterFormlyFieldService = inject(
    CostcenterSearchFormlyFieldService
  );
  readonly toastr = inject(ToastrService);
  readonly fileService = inject(FileService);
  readonly employmentClient = inject(EmploymentClient);
  readonly billingAreaClient = inject(BillingAreaClient);
  readonly locationClient = inject(LocationClient);

  @ViewChild('sharedTemplates', { static: true })
  sharedTemplates!: CellTemplatesComponent;

  @ViewChild('datepickerUsageUntilCellTemplate', { static: true })
  datepickerUsageUntilCellTemplate: TemplateRef<void>;

  @ViewChild('datepickerRequestedUsageUntilCellTemplate', { static: true })
  datepickerRequestedUsageUntilCellTemplate: TemplateRef<void>;

  @ViewChild('deleteCellTemplate', { static: true })
  deleteCellTemplate: TemplateRef<void>;

  @ViewChild('inputCellTemplate', { static: true })
  inputCellTemplate: TemplateRef<void>;

  @ViewChild('workspaceInput') workspaceInput: NgModel;

  override formModel: any = {
    shortTitle: '',
    description: '',
    organisation_unit: '',
    department_similar: '',
    desiredDate: null,
    companyCost: '',
    costCenterId: '',
    searchContact: null,
    contactPerson: null,
    costcenter: null,
    areaReturnUsages: [],
    files: [],
  };

  override form: FormGroup;

  cardSearch: CardConfig = {
    header: {
      title: {
        label: this.translateService.instant(
          'location.myLocation.label__search_location'
        ),
      },
    },
  };

  currentUserEmail = this.msalService.instance.getActiveAccount()?.idTokenClaims
    ?.email as string;

  currentUser: EmploymentSearchResultDto;

  costCenterId: string;
  locationId: string;

  currentCostCenterId: string = '';
  currentLocationId: string = '';

  columns: MtxGridColumn[];
  columnsVb: MtxGridColumn[];

  public dataUsageSelection$ = new BehaviorSubject<
    AreaManagementUsageTableViewModel[]
  >([] as AreaManagementUsageTableViewModel[]);

  public dataVbUsageSelection$ = new BehaviorSubject<
    AreaReturnSbuUsageTableViewModel[]
  >([] as AreaReturnSbuUsageTableViewModel[]);

  fieldsInExpansionTemplate: string[] = [];
  usageSelectionDataTable$: Observable<AreaManagementUsageTableViewModel[]>;
  columnsSelectedUsages: MtxGridColumn[];
  columnsSelectedUsagesVb: MtxGridColumn[];

  selectedRowsSubject$ = new BehaviorSubject<
    AreaManagementUsageTableViewModel[]
  >([]);

  vbSelectedRowsSubject$ = new BehaviorSubject<
    IAreaReturnSbuUsageTableViewModel[]
  >([]);

  billingAreasSubject$ = new BehaviorSubject<BaseSelectViewModel[]>([]);

  isVb: boolean = false;

  today = new Date();

  public ngOnInit(): void {
    this.breadcrumbsService.setBreadcrumbs([
      {
        label: this.translateService.instant('area_return.title'),
      },
    ]);

    this.successTitle = this.translateService.instant(
      'ticket.create.success.title'
    );

    this.successMessage = this.translateService.instant(
      'ticket.create.success.message_short'
    );

    this.columns = [
      {
        header: this.translateService.instant(
          'area_return.label__selected_usage'
        ),
        field: 'selected',
        cellTemplate: this.sharedTemplates.selectionCellTemplateRef,
      },
      {
        header: this.translateService.instant('area_return.label__room'),
        field: 'roomName',
      },
      {
        header: this.translateService.instant('area_return.label__workSpace'),
        field: 'workspaceName',
      },
      {
        header: this.translateService.instant('area_return.label__endOfUse'),
        field: 'usageUntil',
      },
      {
        header: this.translateService.instant(
          'area_return.label__buildingFloor'
        ),
        field: 'buildingFloorTitle',
      },
      {
        header: this.translateService.instant('area_return.label__m2'),
        field: 'area',
      },
      {
        header: this.translateService.instant('area_return.label__validUntil'),
        field: 'originalUsageUntil',
      },
      {
        header: this.translateService.instant('area_return.label__costCenter'),
        field: 'costCenter',
      },
    ];

    this.columnsSelectedUsages = [
      {
        header: this.translateService.instant(
          'area_return.label__delete_usage'
        ),
        field: 'delete',
        cellTemplate: this.deleteCellTemplate,
      },
      {
        header: this.translateService.instant('area_return.label__endOfUse'),
        field: 'usageUntil',
        cellTemplate: this.datepickerUsageUntilCellTemplate,
      },
      {
        header: this.translateService.instant('area_return.label__room'),
        field: 'roomName',
      },
      {
        header: this.translateService.instant('area_return.label__workSpace'),
        field: 'workspaceName',
      },
      {
        header: this.translateService.instant(
          'area_return.label__buildingFloor'
        ),
        field: 'buildingFloorTitle',
      },
      {
        header: this.translateService.instant('area_return.label__m2'),
        field: 'area',
      },
      {
        header: this.translateService.instant('area_return.label__validUntil'),
        field: 'originalUsageUntil',
      },
      {
        header: this.translateService.instant('area_return.label__costCenter'),
        field: 'costCenter',
      },
    ];

    this.columnsVb = [
      {
        header: this.translateService.instant(
          'area_return.label__selected_usage'
        ),
        field: 'selected',
        cellTemplate: this.sharedTemplates.selectionCellTemplateRef,
      },
      {
        header: this.translateService.instant('area_return.label__costCenter'),
        field: 'costCenterId',
      },
      {
        header: this.translateService.instant('area_return.label__quantity'),
        field: 'numberOfWorkspaces',
      },
      {
        header: this.translateService.instant('area_return.label__validUntil'),
        field: 'usageUntil',
        cellTemplate: this.sharedTemplates.dateCellTemplate,
      },
    ];

    this.columnsSelectedUsagesVb = [
      {
        header: this.translateService.instant(
          'area_return.label__delete_usage'
        ),
        field: 'delete',
        cellTemplate: this.deleteCellTemplate,
      },
      {
        header: this.translateService.instant('area_return.label__endOfUse'),
        field: 'requestedUsageUntil',
        cellTemplate: this.datepickerRequestedUsageUntilCellTemplate,
      },
      {
        header: this.translateService.instant('area_return.label__costCenter'),
        field: 'costCenterId',
      },
      {
        header: this.translateService.instant(
          'area_return.label__quantity_current'
        ),
        field: 'numberOfWorkspaces',
      },
      {
        header: this.translateService.instant(
          'area_return.label__quantity_selection'
        ),
        field: 'numberOfWorkspacesSelection',
        cellTemplate: this.inputCellTemplate,
      },
      {
        header: this.translateService.instant('area_return.label__validUntil'),
        field: 'usageUntil',
        cellTemplate: this.sharedTemplates.dateCellTemplate,
      },
    ];

    this.loading = true;
    this.loadingMessage = this.translateService.instant('form.loading');

    this.employmentClient.getEmployeeByEmail(this.currentUserEmail).subscribe({
      next: res => {
        this.currentUser = res;
        this.formFields = this.getFormFields();
        this.loading = false;
      },
    });

    this.card = {
      footer: {
        button1: {
          label: this.translateService.instant('forward'),
          disabled: false,
          onClick: () => {
            this.fileService.setFileAttachmentType(
              this.form.value,
              DocumentType.Sonstiges
            );
            if (!this.validateVbSelectedUsages()) {
              this.workspaceInput.control.markAsTouched();

              return;
            }

            const selectedRows =
              this.selectedRowsSubject$.getValue().length > 0
                ? this.selectedRowsSubject$.getValue()
                : this.vbSelectedRowsSubject$.getValue();

            if (selectedRows.length == 0) {
              this.toastr.error(
                this.translateService.instant(
                  'ticket.create.area_return_required'
                )
              );
              return;
            }

            this.validateForm();
          },
        },
      },
    };

    this.areaManagementService.rowUpdated$
      .pipe(
        distinctUntilChanged((prev, curr) => {
          return JSON.stringify(prev) === JSON.stringify(curr);
        })
      )
      .subscribe(newRow => {
        if (newRow.length > 0) {
          this.disableLocationField();
        } else {
          this.enableLocationField();
        }
        if (Array.isArray(newRow)) {
          const rowDataArray = newRow
            .map(item => ({
              ...item.rowData,
              usageUntil: this.areaManagementService.getUsageUntil(
                this.form.get('desiredDate')
              ),
            }))
            .filter(data => data);
          const currentRows = this.selectedRowsSubject$.getValue();
          const updatedRows = [...currentRows, ...rowDataArray].filter(
            (item, index, self) =>
              index === self.findIndex(t => t.id === item.id)
          );
          this.selectedRowsSubject$.next(updatedRows);

          const updatedData = this.dataUsageSelection$.value.map(item => ({
            ...item,
            usageSelected: this.isUsageSelected(item),
          }));
          this.dataUsageSelection$.next(updatedData);

          this.updateSelectedUsesField();
          this.cd.detectChanges();
        }
      });

    this.areaManagementService.rowVbUpdated$
      .pipe(
        distinctUntilChanged((prev, curr) => {
          return JSON.stringify(prev) === JSON.stringify(curr);
        })
      )
      .subscribe(newRow => {
        if (newRow.length > 0) {
          this.disableLocationField();
        } else {
          this.enableLocationField();
        }
        if (Array.isArray(newRow)) {
          const rowDataArray = newRow
            .map(item => ({
              ...item.rowData,
              requestedUsageUntil: this.areaManagementService.getUsageUntil(
                this.form.get('desiredDate')
              ),
              numberOfWorkspacesSelection: item.rowData.numberOfWorkspaces,
            }))
            .filter(data => data);
          const currentRows = this.vbSelectedRowsSubject$.getValue();
          const updatedRows = [...currentRows, ...rowDataArray].filter(
            (item, index, self) =>
              index === self.findIndex(t => t.id === item.id)
          );
          this.vbSelectedRowsSubject$.next(updatedRows);

          const updatedData = this.dataVbUsageSelection$.value.map(item => ({
            ...item,
            usageSelected: this.isVbUsageSelected(item),
          }));
          this.dataVbUsageSelection$.next(updatedData);

          this.updateVbSelectedUsesField();
          this.cd.detectChanges();
        }
      });

    this.cd.detectChanges();
  }

  enableLocationField() {
    if (this.formFields) {
      const locationSearchField = this.formFields[0]?.fieldGroup?.find(
        f => f.key === 'searchResult'
      );
      if (locationSearchField) {
        locationSearchField.props = {
          ...locationSearchField.props,
          disabled: false,
        };

        const locationControl = this.form.get('searchResult');
        if (locationControl) {
          locationControl.enable();
        }

        this.cd.detectChanges();
      }
    }
  }

  disableLocationField() {
    const locationSearchField = this.formFields[0].fieldGroup.find(
      f => f.key === 'searchResult'
    );
    if (locationSearchField) {
      locationSearchField.props = {
        ...locationSearchField.props,
        disabled: true,
      };

      const locationControl = this.form.get('searchResult');
      if (locationControl) {
        locationControl.disable();
      }

      this.cd.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.resetUsageData();
  }

  resetUsageData() {
    this.dataUsageSelection$.next([]);
    this.selectedRowsSubject$.next([]);
    this.dataVbUsageSelection$.next([]);
    this.vbSelectedRowsSubject$.next([]);
    this.areaManagementService.resetRows();
  }

  onDateChange(row: AreaManagementUsageTableViewModel, newDate: Date) {
    const currentRows = this.selectedRowsSubject$.getValue();
    const rows = this.areaManagementService.onDateChange(
      row,
      newDate,
      currentRows
    );
    this.selectedRowsSubject$.next([...rows]);
  }

  onDateChangeVb(row: IAreaReturnSbuUsageTableViewModel, newDate: Date) {
    const currentRows = this.vbSelectedRowsSubject$.getValue();
    const rows = this.areaManagementService.onDateChangeVb(
      row,
      newDate,
      currentRows
    );
    this.vbSelectedRowsSubject$.next([...rows]);
  }

  getFormFields(): FormlyFieldConfig[] {
    return [
      {
        type: 'flex-layout',
        fieldGroup: [
          {
            wrappers: ['form-field'],
            key: 'shortTitle',
            type: 'input',
            props: {
              label: this.translateService.instant(
                'ticket.create.space_request.short_title'
              ),
              visibleInConfirm: true,
              required: true,
            },
          },
          {
            wrappers: ['form-field'],
            key: 'description',
            type: 'textarea',
            props: {
              label: this.translateService.instant(
                'ticket.create.space_request.description'
              ),
              visibleInConfirm: true,
              required: true,
              autosize: true,
              autosizeMinRows: 5,
            },
          },
          {
            key: 'organisation_unit',
            type: 'input',
            props: {
              label: this.translateService.instant(
                'area_return.label__organisation_unit'
              ),
            },
          },
          {
            key: 'department_similar',
            type: 'input',
            props: {
              label: this.translateService.instant(
                'area_return.label__department_similar'
              ),
            },
          },
          {
            type: 'chapter',
            key: 'searchResult',
            props: {
              chapterTitle: this.translateService.instant(
                'area_return.label__search'
              ),
            },
          },
          ...this.locationFormlyFieldService.autocompleteSearch(
            false,
            null,
            true,
            id => this.onSelectLocation(id),
            null,
            () => this.onDeleteLocation(),
            this.translateService.instant(
              'location.shared.delete_location_search_tooltip'
            )
          ),
          {
            type: 'select',
            key: 'areaType',
            props: {
              label: this.translateService.instant(
                'area_return.label__area_type'
              ),
              options: [
                {
                  value: AreaType.WorkplaceOrArea,
                  label: AreaType.WorkplaceOrArea,
                },
                {
                  value: AreaType.BillingArea,
                  label: AreaType.BillingArea,
                },
              ],
            },
            hooks: {
              onInit: field => {
                field?.formControl?.valueChanges.subscribe({
                  next: value => {
                    if (value === AreaType.BillingArea) {
                      this.isVb = true;
                      this.dataUsageSelection$.next([]);
                      this.selectedRowsSubject$.next([]);
                      this.locationClient
                        .getBillingAreas(this.locationId)
                        .subscribe({
                          next: billingAreas => {
                            this.billingAreasSubject$.next(billingAreas);
                            const fieldBillingArea =
                              this.formFields[0].fieldGroup.find(
                                f => f.key === 'billingArea'
                              );
                            fieldBillingArea.props.options = billingAreas.map(
                              (type: BaseSelectViewModel) => ({
                                value: type.id,
                                label: type.name,
                              })
                            );
                            this.cd.detectChanges();
                            this.loading = false;
                          },
                        });
                    } else {
                      this.isVb = false;
                    }
                  },
                });
              },
            },
          },
          {
            type: 'select',
            key: 'billingArea',
            hideExpression: () => !this.isVb,
            props: {
              label: this.translateService.instant(
                'area_return.label__billingArea'
              ),
              options: [],
              required: true,
            },
            hooks: {
              onInit: field => {
                field?.formControl?.valueChanges.subscribe({
                  next: value => {
                    if (value && this.currentLocationId) {
                      this.billingAreaClient
                        .getAreaReturnSbuUsageTable(value)
                        .subscribe({
                          next: res => {
                            this.dataVbUsageSelection$.next(res);
                            this.vbSelectedRowsSubject$.next([]);
                            this.loading = false;
                          },
                        });
                    }
                  },
                });
              },
            },
          },
          {
            key: 'costcenter',
            hideExpression: () => this.isVb,
            fieldGroup: [
              ...this.costCenterFormlyFieldService.autocompleteSearch(
                this.translateService.instant(
                  'access_orderer.filter.costcenter.title'
                ),
                true,
                null,
                '',
                id => this.onSelectCostcenter(id),
                this.onDeleteCostcenter.bind(this),
                true,
                this.translateService.instant(
                  'location.autocomplete.deleteCostCenter_tooltip'
                )
              ),
            ],
          },
          {
            type: 'datepicker',
            key: 'desiredDate',
            className: 'description-margin',
            props: {
              label: this.translateService.instant(
                'area_return.label__desired_date'
              ),
              description: this.translateService.instant(
                'area_return.note_desired_date'
              ),
              datepickerOptions: {
                filter: (date: Date): boolean => this.dateFilter(date),
                min: this.getNextAvailableQuarterEnd(),
              },
              required: true,
            },
            hooks: {
              onInit: field => {
                field.formControl?.setValue(this.getNextAvailableQuarterEnd());
              },
            },
          },
          {
            key: 'companyCost',
            type: 'input',
            props: {
              label: this.translateService.instant(
                'area_return.label__company_cost'
              ),
            },
          },
          ...fileAttachments(this.translateService, true),
          {
            key: 'usage_selection',
            type: 'usage-selection',
            hideExpression: () => this.isVb,
            props: {
              columns: this.columns,
              data$: this.dataUsageSelection$,
              locationId: this.locationId,
              costCenterId: this.costCenterId,
            },
          },
          {
            key: 'selected_uses',
            type: 'selected-uses',
            className: 'no-result-styling',
            hideExpression: () => this.isVb,
            props: {
              columns: this.columnsSelectedUsages,
              data$: this.selectedRowsSubject$,
              attributes: {
                headerStyle: 'color: black;',
              },
              noResultsText: this.translateService.instant(
                'ticket.create.space_return.returned_area.no_results'
              ),
            },
          },
          {
            key: 'usage_selection_vb',
            type: 'usage-selection',
            hideExpression: () => !this.isVb,
            props: {
              columns: this.columnsVb,
              data$: this.dataVbUsageSelection$,
              locationId: this.locationId,
              costCenterId: this.costCenterId,
              isVb: true,
            },
          },
          {
            key: 'selected_uses_vb',
            type: 'selected-uses',
            className: 'no-result-styling',
            hideExpression: () => !this.isVb,
            props: {
              columns: this.columnsSelectedUsagesVb,
              data$: this.vbSelectedRowsSubject$,
              attributes: {
                headerStyle: 'color: black;',
              },
              noResultsText: this.translateService.instant(
                'ticket.create.space_return.returned_area.no_results'
              ),
            },
          },
          {
            wrappers: [],
            fieldGroup: [
              {
                type: 'chapter',
                props: {
                  chapterTitle: this.translateService.instant(
                    'ticket.create.headline__search_creator'
                  ),
                },
              },
              {
                key: 'searchContact',
                fieldGroup: [
                  ...this.employeeSearchFormlyFieldService.autocompleteSearch(
                    'ticket.create.placeholder__search_contact',
                    null,
                    true,
                    true,
                    this.currentUserEmail,
                    null,
                    null,
                    this.currentUser,
                    this.translateService.instant(
                      'location.autocomplete.deleteContact_tooltip'
                    )
                  ),
                ],
              },
            ],
          },
          {
            fieldGroup: [
              {
                type: 'chapter',
                props: {
                  chapterTitle: this.translateService.instant(
                    'ticket.create.label__processor'
                  ),
                },
              },
              {
                key: 'contactPerson',
                fieldGroup: [
                  ...this.employeeSearchFormlyFieldService.autocompleteSearch(
                    'ticket.create.placeholder__search_processor',
                    null,
                    false,
                    true,
                    null,
                    null,
                    null,
                    null,
                    this.translateService.instant(
                      'location.autocomplete.deleteContact_tooltip'
                    )
                  ),
                ],
              },
            ],
          },
          ...emailcc(this.translateService, this.onEmailChange.bind(this)),
        ],
      },
    ];
  }

  costcenter = new FormControl();

  onSelectCostcenter(id: string) {
    this.costcenter.setValue(id);
  }

  onSelectLocation(id: string) {
    if (id !== this.currentLocationId) {
      const fieldBillingArea = this.formFields[0].fieldGroup.find(
        f => f.key === 'billingArea'
      );

      this.dataVbUsageSelection$.next([]);
      this.vbSelectedRowsSubject$.next([]);
      fieldBillingArea.formControl.reset();

      this.loading = true;
      this.locationClient.getBillingAreas(id).subscribe({
        next: billingAreas => {
          this.billingAreasSubject$.next(billingAreas);
          fieldBillingArea.props.options = billingAreas.map(
            (type: BaseSelectViewModel) => ({
              value: type.id,
              label: type.name,
            })
          );
          this.cd.detectChanges();
          this.loading = false;
        },
      });
    }
  }

  onDeleteLocation() {
    this.currentLocationId = null;
    this.resetUsageData();

    this.form.get('billingArea')?.reset();
    this.formModel.billingArea = null;

    const fieldBillingArea = this.formFields[0].fieldGroup.find(
      f => f.key === 'billingArea'
    );

    if (fieldBillingArea) {
      fieldBillingArea.props.options = [];
    }

    this.billingAreasSubject$.next([]);
  }

  onDeleteCostcenter() {
    this.costcenter.reset();
    this.selectedRowsSubject$.next([]);
    this.dataUsageSelection$.next([]);
  }

  onModelChange(model: any) {
    if (model.costcenter?.searchResult !== null) {
      this.costCenterId = model.costcenter?.searchResult?.costCenter;
      this.formModel.costCenterId = this.costCenterId;
    }

    if (model.searchResult !== null) {
      this.locationId = model.searchResult?.id;
    }

    this.onSelectionChange();
  }

  onSelectionChange() {
    if (!this.isVb) {
      if (!this.locationId || !this.costCenterId) return;

      if (
        this.currentLocationId === this.locationId &&
        this.currentCostCenterId === this.costCenterId
      )
        return;

      this.currentLocationId = this.locationId;
      this.currentCostCenterId = this.costCenterId;
    } else {
      if (!this.locationId) return;

      if (this.currentLocationId === this.locationId) return;

      this.currentLocationId = this.locationId;
    }

    this.loading = true;

    if (
      !this.form.value.areaType ||
      this.form.value.areaType === AreaType.WorkplaceOrArea
    ) {
      this.usageSelectionDataTable$ = this.areaManagementService
        .getUsagesForLocationAndCostcenter(this.locationId, this.costCenterId)
        .pipe(
          debounceTime(300),
          catchError(() => {
            this.loading = false;
            this.cd.detectChanges();
            return of([] as AreaManagementUsageTableViewModel[]);
          })
        );
      this.usageSelectionDataTable$.subscribe(data => {
        if (data !== this.dataUsageSelection$.value) {
          this.dataUsageSelection$.next(data);
          this.updateUsageSelectionField();

          this.loading = false;
          this.cd.detectChanges();
        }
      });
    } else {
      this.loading = false;
      this.billingAreasSubject$.next([]);
    }
  }

  private updatingFormFields = false;

  updateUsageSelectionField() {
    if (this.updatingFormFields) {
      return;
    }

    this.updatingFormFields = true;
    const usageSelectionField = this.formFields[0].fieldGroup.find(
      f => f.key === 'usage_selection'
    );

    const index = this.formFields.findIndex(group =>
      group.fieldGroup?.some(field => field.key === 'usage_selection')
    );

    if (index !== -1) {
      const group = this.formFields[index];
      const fieldIndex = group.fieldGroup.findIndex(
        field => field.key === 'usage_selection'
      );

      if (fieldIndex !== -1) {
        group.fieldGroup[fieldIndex] = usageSelectionField;
        this.formFields = [...this.formFields];
      }
    }

    this.updatingFormFields = false;
  }

  updateSelectedUsesField() {
    if (this.formFields) {
      if (this.updatingFormFields) {
        return;
      }

      this.updatingFormFields = true;
      const usageSelectedUses = this.formFields[0].fieldGroup.find(
        f => f.key === 'selected_uses'
      );

      const index = this.formFields?.findIndex(group =>
        group.fieldGroup?.some(field => field.key === 'selected_uses')
      );

      if (index !== -1) {
        if (this.formFields) {
          const group = this.formFields[index];
          const fieldIndex = group.fieldGroup.findIndex(
            field => field.key === 'selected_uses'
          );

          if (fieldIndex !== -1) {
            group.fieldGroup[fieldIndex] = usageSelectedUses;
            this.selectedRowsSubject$.subscribe({
              next: data => {
                this.form.value.selected_uses = data;
              },
            });
            this.formFields = [...this.formFields];
          }
        }
      }

      this.updatingFormFields = false;
    }
  }

  updateVbSelectedUsesField() {
    if (this.formFields) {
      if (this.updatingFormFields) {
        return;
      }

      this.updatingFormFields = true;
      const usageSelectedUses = this.formFields[0].fieldGroup.find(
        f => f.key === 'selected_uses_vb'
      );

      const index = this.formFields?.findIndex(group =>
        group.fieldGroup?.some(field => field.key === 'selected_uses_vb')
      );

      if (index !== -1) {
        if (this.formFields) {
          const group = this.formFields[index];
          const fieldIndex = group.fieldGroup.findIndex(
            field => field.key === 'selected_uses_vb'
          );

          if (fieldIndex !== -1) {
            group.fieldGroup[fieldIndex] = usageSelectedUses;
            this.vbSelectedRowsSubject$.subscribe({
              next: data => {
                this.form.value.selected_uses_vb = data;
              },
            });
            this.formFields = [...this.formFields];
          }
        }
      }

      this.updatingFormFields = false;
    }
  }

  public onEmailChange(emails: string) {
    this.form.get('ccemail')?.setValue(emails as never);
  }

  public override clientEndpoint = data => {
    this.loadingMessage = this.translateService.instant('form.loading_message');
    if (this.isVb) {
      return this.areaManagementService.createSbuAreaReturnTicket(data);
    } else {
      return this.areaManagementService.createCostCenterAreaReturnTicket(data);
    }
  };

  protected override prepareSubmit = data => {
    const formRawValue = this.form.getRawValue();

    const areaReturnUsages =
      this.selectedRowsSubject$.getValue().length > 0
        ? this.selectedRowsSubject$.getValue()
        : this.vbSelectedRowsSubject$.getValue();

    let formattedAreaReturnUsages: AreaReturnUsage[] = areaReturnUsages.map(
      item => ({
        requestedDate:
          this.isValidDate(item.usageUntil?.toString()) === true
            ? new Date(item.usageUntil)
            : this.formModel.desiredDate,
        costCenterUsageId: item.costCenterId,
        usageId: item.id,
        quantity: item.numberOfWorkspacesSelection,
      })
    );

    const d = data;
    if (!d.searchContact?.searchResult?.id) {
      return null;
    }

    if (this.isVb) {
      formattedAreaReturnUsages = areaReturnUsages.map(item => ({
        requestedDate:
          this.isValidDate(item.requestedUsageUntil?.toString()) === true
            ? new Date(item.requestedUsageUntil)
            : this.formModel.desiredDate,
        costCenterUsageId: item.costCenterId,
        usageId: item.id,
        quantity: item.numberOfWorkspacesSelection,
      }));

      const req: RequestFileWrapperOfSbuAreaReturnTicketRequest = {
        entity: {
          title: d.shortTitle,
          description: d.description,
          organisationalUnit: d.organisation_unit,
          department: d.department_similar,
          archObjId: formRawValue.searchResult?.id,
          billingAreaId: d.billingArea,
          requestedDate: d.desiredDate,
          costCenterSociety: d.companyCost,
          notifyingContactId: d.searchContact?.searchResult?.id,
          contactPersonId: d.contactPerson?.searchResult?.id,
          mails: d.ccemail,
          areaReturnUsages: formattedAreaReturnUsages,
        },
        files: d.attachments || [],
      };
      return req;
    } else {
      const req: RequestFileWrapperOfCostCenterAreaReturnTicketRequest = {
        entity: {
          title: d.shortTitle,
          description: d.description,
          organisationalUnit: d.organisation_unit,
          department: d.department_similar,
          archObjId: formRawValue.searchResult?.id,
          costCenterId: d.costcenter?.searchResult?.costCenter,
          requestedDate: d.desiredDate,
          costCenterSociety: d.companyCost,
          notifyingContactId: d.searchContact?.searchResult?.id,
          contactPersonId: d.contactPerson?.searchResult?.id,
          mails: d.ccemail,
          areaReturnUsages: formattedAreaReturnUsages,
        },
        files: d.attachments || [],
      };

      return req;
    }
  };

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  onDeleteSelectedUsage(row, isVb: boolean) {
    if (isVb) {
      this.areaManagementService.deleteRowVb(row.id);

      const rowsUpdate = this.vbSelectedRowsSubject$.value.filter(
        item => item.id !== row.id
      );
      this.vbSelectedRowsSubject$.next(rowsUpdate);

      const updatedData = this.dataVbUsageSelection$.value.map(item => ({
        ...item,
        usageSelected: this.isVbUsageSelected(item),
      }));
      this.dataVbUsageSelection$.next(updatedData);
    } else {
      this.areaManagementService.deleteRow(row.id);

      const rowsUpdate = this.selectedRowsSubject$.value.filter(
        item => item.id !== row.id
      );
      this.selectedRowsSubject$.next(rowsUpdate);

      const updatedData = this.dataUsageSelection$.value.map(item => ({
        ...item,
        usageSelected: this.isUsageSelected(item),
      }));
      this.dataUsageSelection$.next(updatedData);
    }
  }

  isUsageSelected(entry: AreaManagementUsageTableViewModel): boolean {
    return this.selectedRowsSubject$.value?.some(
      selectedRow => selectedRow.id === entry.id
    );
  }

  isVbUsageSelected(entry: AreaReturnSbuUsageTableViewModel): boolean {
    return this.vbSelectedRowsSubject$.value?.some(
      selectedRow => selectedRow.id === entry.id
    );
  }

  public override getStatusPath() {
    return '/dashboard';
  }

  validateVbSelectedUsages() {
    return !this.vbSelectedRowsSubject$.value.some(
      row =>
        row.numberOfWorkspacesSelection > row.numberOfWorkspaces ||
        row.numberOfWorkspacesSelection < 1 ||
        !row.numberOfWorkspacesSelection
    );
  }

  isValidDate(date: string) {
    return !isNaN(Date.parse(date));
  }

  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const date = new Date(d);
    date.setHours(0, 0, 0, 0);

    const year = date.getFullYear();

    const quarterEnds = this.getQuarterEnds(year);

    const blockedPeriods = this.getBlockedPeriods(quarterEnds);

    const isQuarterEnd = quarterEnds.some(
      qEnd => date.getTime() === qEnd.getTime()
    );

    if (isQuarterEnd) {
      for (const block of blockedPeriods) {
        if (
          date.getTime() === block.end.getTime() &&
          this.today > block.start
        ) {
          return false;
        }
      }
      return true;
    }

    return false;
  };

  getNextAvailableQuarterEnd(): Date {
    const year = this.today.getFullYear();

    const quarterEnds = this.getQuarterEnds(year);

    const blockedPeriods = this.getBlockedPeriods(quarterEnds);

    for (let i = 0; i < quarterEnds.length; i++) {
      const qEnd = quarterEnds[i];
      const block = blockedPeriods[i];

      if (this.today < block.start) {
        qEnd.setHours(12);
        return new Date(qEnd);
      }
    }
    return new Date(year + 1, 2, 31);
  }

  getQuarterEnds(year: number) {
    return [
      new Date(year, 2, 31), // 31. März
      new Date(year, 5, 30), // 30. Juni
      new Date(year, 8, 30), // 30. September
      new Date(year, 11, 31), // 31. Dezember
    ];
  }

  getBlockedPeriods(quarterEnds: Date[]) {
    return quarterEnds.map(qEnd => {
      const blockStart = new Date(qEnd);
      blockStart.setDate(qEnd.getDate() - 42);
      return { start: blockStart, end: qEnd };
    });
  }
}
